import React from 'react';

import { gql } from '@soundxyz/gql-string';
import { FollowButton } from '@components/basics/FollowButton';
import { Avatar } from '@components/basics/Images/Avatar';
import { VerifiedTooltip } from '@components/main-components/tooltip/VerifiedTooltip';
import {
  AVATAR_SIZE_USER_HOVER_CARD_CONTENT,
  UserHoverCardContentUI,
} from '@components/main-components/user/UserHoverCardContentUI';
import {
  getFragment,
  useQuery,
  UserInfoForToolTipDocument,
  UserInfoToolTipFragmentDoc,
} from '@graphql/reactQuery';
import { webappUriPath } from '@utils/url';

/*#__PURE__*/ gql(/* GraphQL */ `
  query userInfoForToolTip($userId: UUID!) {
    user(id: $userId) {
      id
      ...UserInfoToolTip
    }
  }
  fragment UserInfoToolTip on User {
    id
    publicAddress
    webappUri
    username
    followerCount
    followingCount
    nftsOwned
    artist {
      id
      numReleases
    }
    avatar {
      id
      url
    }
    creditAllocations {
      id
    }
  }
`);

export const UserHoverCardContent = ({ userId }: { userId: string }) => {
  const { data } = useQuery(UserInfoForToolTipDocument, {
    variables: {
      userId,
    },
    staleTime: 0,
  });

  const userInfo = data?.data.user;
  if (!userInfo) {
    return null;
  }

  const user = getFragment(UserInfoToolTipFragmentDoc, userInfo);
  const { avatar, publicAddress, username, webappUri } = user;
  return (
    <UserHoverCardContentUI
      user={{ ...user, webappUri: webappUriPath(webappUri) }}
      followButton={
        <FollowButton userId={user.id} dark size="M" sourceLocation="User Hover Card" />
      }
      verified={<VerifiedTooltip noTooltip />}
      avatar={
        <Avatar
          src={avatar?.url}
          walletAddress={publicAddress}
          username={username}
          borderRadius={6}
          size={AVATAR_SIZE_USER_HOVER_CARD_CONTENT}
          webappUri={webappUri}
        />
      }
    />
  );
};
